<template>
	<div class="d-inline-flex align-items-center">
		<nk-drop-button @click="(b, e) => buttonClicked(b, e)" :options="settings.dropSettings"></nk-drop-button>
	</div>
</template>
<script>
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import ImportFromExcelMap from './import-from-excel-map'
	import emptyId from '~/statics/empty-id'
	import _ from 'lodash'
	import { isEmpty } from '@/statics/validators'
	import { toastInstance } from '@/plugins/toast'
	import { i18nInstance } from '@/plugins/localization'

	export default {
		props: {
			options: { type: Object, default: () => { } },
		},
		emits: ['click'],
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			}
		},
		data() {
			return {
				settings: {
					dropSettings: {},
					hideExport: false,
					hideImport: false
				},
				exportButton: {
					title: this.$t('export-to-excel'),
					icon: 'file-export',
					isPrimary: false,
					handle: (button, page, e) => {
						this.exportToExcel(this.settings.exportIds())
					},
				},
				importButton: {
					title: this.$t('import-from-excel'),
					icon: 'file-import',
					isPrimary: false,
					handle: (button, page, e) => {
						this.importFromExcel()
					},
				},
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			this.prepareExcelButton()
		},
		methods: {
			prepareExcelButton() {
				var button = {
					isPrimary: false,
					icon: 'file-excel',
					shortcut: $sc.find('excel'),
					title: this.$t('excel'),
					handle: (button, page, e) => { },
					items: [],
					selfButton: true,
					hideTitle: this.settings.hideTitle !== undefined ? this.settings.hideTitle : false,
					hideTooltip: this.settings.hideTooltip !== undefined ? this.settings.hideTooltip : true,
					hideShortcut: true,
					tooltipEnabled: this.settings.tooltipEnabled !== undefined ? this.settings.tooltipEnabled : false,
				}

				if (!this.settings.hideExport)
					button.items.push(this.exportButton)

				if (!this.settings.hideImport)
					button.items.push(this.importButton)

				if (this.settings.exportButtons) {
					this.settings.exportButtons.forEach(but => {
						but.handle = () => this.exportToExcel(but.exportIds())
						button.items.push(but)
					})
				}


				button.handle = this.settings.hideExport ? this.importButton.handle : this.exportButton.handle

				this.settings.dropSettings = button
			},
			buttonClicked(button, e) {
				this.$emit('click', button)
			},
			exportToExcel(ids) {
				// let ids = this.settings.exportIds()
				if ((ids.some(x => isEmpty(x))) || (this.settings.mapSettings.type !== 'FloatingCenter' && !ids.length)) {
					this.$toast(this.$t('import-from-excel-map.m.select-one', { type: this.$t(`import-from-excel-map.types.${this.settings.mapSettings.type.toLowerCase()}`) }), { type: 'info' })
					return
				}

				if (this.settings.validateExportData && !this.settings.validateExportData()) {
					return
				}

				// for (let id of ids) {
				// 	if (!id || id === emptyId) {
				// 		this.$toast(this.$t('import-from-excel-map.m.select-one', { type: this.$t(`import-from-excel-map.types.${this.settings.mapSettings.type.toLowerCase()}`) }), { type: 'info' })
				// 		return
				// 	}
				// }

				let metaData = {}

				if (this.settings.getMetaData) {
					metaData = this.settings.getMetaData()
				}

				post(Endpoints.getUrl(this.urlGenerator('download.export')), { ...this.settings.mapSettings, exportIds: ids, ...metaData }, null, { silent: true, })
					.then((res) => {
						const url = window.URL.createObjectURL(
							new Blob([res.data], { type: res.headers['content-type'] })
						)
						const a = document.createElement('a')
						a.style.display = 'none'
						a.href = url
						// the filename you want
						a.download = `nikan-${this.settings.mapSettings.type.toLowerCase()}-excel` + (res.headers.extension || 'xlsx')
						document.body.appendChild(a)
						a.click()
						window.URL.revokeObjectURL(url)
					})
					.catch((error) => {
						this.$toast(this.$t('not-found-for-toast-navigation',))

					})
			},
			urlGenerator(path) {
				return `${this.settings.module}.${path}`
			},
			importFromExcel() {

				var options = _.extend(this.settings.mapSettings, { module: this.settings.module })

				this.showModal({
					component: ImportFromExcelMap,
					options: options,
				})
					.then((result) => {
						if (this.settings.callback && typeof this.settings.callback === 'function') {
							this.settings.callback()
						}
					})
					.catch((err) => { })
			},
		}
	}
</script>
